import { Space, Table } from "antd";
import moment from "moment";

import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function DataTaskTable(props: any) {
  const navigate = useNavigate();

  // Define the columns for the table
  const columns = [
    {
      dataIndex: "TaskName",
      title: "Task Name",
    },
    {
      dataIndex: "descriptions",
      title: "Description",
    },
    {
      dataIndex: "status",
      title: "Status",
    },
    {
      dataIndex: "startDates",
      title: "startDates",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "endDates",
      title: "endDates",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/task_view/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={props?.dataSource} // Safe fallback
        pagination={{
          defaultPageSize: 5, // Default number of rows per page
          showSizeChanger: true, // Allows user to change the number of rows per page
          pageSizeOptions: ["2", "10", "20", "50"], // Options for page size
        }}
        rowKey={(record: any) => record.id} // Unique key for each row
      />
    </div>
  );
}

export default DataTaskTable;
